import UploadProgressHelperBase from 'helper/uploadProgressHelperBase';

function UploadProgressHelper() {
}

UploadProgressHelper.prototype = UploadProgressHelperBase;

export default new UploadProgressHelper();
